const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);


const tooltips = document.querySelectorAll('.tooltip-content');

tooltips.forEach(tip => {
  const rect = tip.getBoundingClientRect();

  if (rect.left < 10) {
    tip.style.left = '0px';
    tip.style.transform = 'none';
    tip.classList.add('left-adjusted');
  } else if (rect.right > window.innerWidth - 10) {
    tip.style.right = '0px';
    tip.style.left = 'auto';
    tip.style.transform = 'none';
    tip.classList.add('right-adjusted');
  } else {
    tip.style.left = '50%';
    tip.style.transform = 'translateX(-50%)';
    tip.classList.add('centered');
  }
});



// Show/hide on scroll
window.addEventListener("scroll", function () {
  const backToTop = document.getElementById("backToTop");
  if (backToTop) {
    if (window.scrollY > 200) {
      backToTop.style.display = "block";
    } else {
      backToTop.style.display = "none";
    }
  }
});

// Scroll to top on click
document.getElementById("backToTop")?.addEventListener("click", function () {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
});


document.addEventListener("DOMContentLoaded", () => {
  function setEqualHeights() {
    const items = document.querySelectorAll(".know-what-you-wear-why-chose .max-w-sm");
    if (!items.length) return;

    // reset heights
    items.forEach(el => el.style.minHeight = "");

    // get max height
    let maxH = 0;
    items.forEach(el => maxH = Math.max(maxH, el.offsetHeight));

    // set all to max height
    items.forEach(el => el.style.minHeight = maxH + "px");
  }

  setEqualHeights();
  window.addEventListener("resize", setEqualHeights);
});


 